import { oc } from '@orpc/contract';
import { dashboardQueuesOutputSchema } from '../schemas/dashboard.schemas.js';
/**
 * "Needs attention" (plan §5.7): the four queues a workspace has to work through, each computed in SQL
 * against the tenant's own business day. The pending-approval queue is **empty for a salesperson** —
 * the operation is not refused, because the card is one request and three of its four rows are theirs.
 */
export const getDashboardQueuesContract = oc
    .route({
    method: 'GET',
    path: '/dashboard/queues',
    tags: ['Dashboard'],
    summary: 'The four "needs attention" queues',
})
    .output(dashboardQueuesOutputSchema);
//# sourceMappingURL=get-dashboard-queues.contract.js.map